export default "__VITE_ASSET__B2B1W0el__"